import React from "react";
import DeliveryQueuePage from "../DeliveryQueuePage";

// COD Watch — the same queue, filtered to cash-on-delivery shipments (spec §7).
// `codOnly` sends isCod=true to GET /delivery; the filter is applied server-side against
// the packageDetails JSONB, never by dropping rows from a page client-side.
export default function LogisticsCodWatchPage() {
    return <DeliveryQueuePage codOnly />;
}
